import { CALL_API } from "redux-api-middleware";
import api from "apis/inspectors";
import {
  REQUEST_FR_LIST,
  RECEIVE_FR_LIST,
  ERROR_FR_LIST,

  REQUEST_FR_PAY_SUMMARY,
  RECEIVE_FR_PAY_SUMMARY,
  ERROR_FR_PAY_SUMMARY,

  REQEUST_UPDATE_FIELD_REP,
  RECEIVE_UPDATE_FIELD_REP,
  ERROR_UPDATE_FIELD_REP,

  REQUEST_FR_TEAMLEADERS,
  RECEIVE_FR_TEAMLEADERS,
  ERROR_FR_TEAMLEADERS,

  REQUEST_MINIMAL_FIELD_REP_LIST,
  RECEIVE_MINIMAL_FIELD_REP_LIST,
  ERROR_MINIMAL_FIELD_REP_LIST,

  REQUEST_MINIMAL_FIELD_REP_LIST_FOR_CASE,
  RECEIVE_MINIMAL_FIELD_REP_LIST_FOR_CASE,
  ERROR_MINIMAL_FIELD_REP_LIST_FOR_CASE,

  REQUEST_FR_EXCLUSION_SEARCH_RESULTS,
  RECEIVE_FR_EXCLUSION_SEARCH_RESULTS,
  ERROR_FR_EXCLUSION_SEARCH_RESULTS,
} from "typeConstants";
import responseHandler from "responseHandler";
import { WebApiReduxRequest, HTTP_GET, HTTP_POST, HTTP_PUT, WebApiRequest } from "tools/webservice";
import customerInspectorExclusions from "apis/customerInspectorExclusions";

export const getFieldRepList = (search) => WebApiReduxRequest(
  REQUEST_FR_LIST,
  RECEIVE_FR_LIST,
  ERROR_FR_LIST,
  HTTP_POST,
  api.inspectorList(),
  { searchTerm: search }
);

export const getFieldRepListWithRecentlyTerminated = (search) => WebApiReduxRequest(
  REQUEST_FR_LIST,
  RECEIVE_FR_LIST,
  ERROR_FR_LIST,
  HTTP_POST,
  api.inspectorList(),
  { searchTerm: search, includeRecentlyTerminated: true }
);

export const getMinimalFieldRepList = () => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: api.getMinimalInspectorList(),
        method: HTTP_GET,
        types: [
          REQUEST_MINIMAL_FIELD_REP_LIST,
          {
            type: RECEIVE_MINIMAL_FIELD_REP_LIST,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_MINIMAL_FIELD_REP_LIST,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

export const getPaySummary = (inspectorNumber, payPeriodId) => {
  return dispatch => (
    dispatch({
      [CALL_API]: {
        endpoint: api.getPaySummary(inspectorNumber, payPeriodId),
        method: HTTP_GET,
        types: [
          REQUEST_FR_PAY_SUMMARY,
          {
            type: RECEIVE_FR_PAY_SUMMARY,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_FR_PAY_SUMMARY,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    })
  );
};

export const updateFieldRep = (inspectorNumber, keyValuePairs, callback) => {
  return dispatch => (
    dispatch({
      [CALL_API]: {
        endpoint: api.updateFieldRep(inspectorNumber),
        method: HTTP_POST,
        body: JSON.stringify(keyValuePairs),
        types: [
          REQEUST_UPDATE_FIELD_REP,
          {
            type: RECEIVE_UPDATE_FIELD_REP,
            payload: (action, state, res) => {
              if (callback) callback();
              res.json()
                .then(data => {
                  return data;
                });
            }
          }, {
            type: ERROR_UPDATE_FIELD_REP,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    })
  );
};

export const getAllTeamLeaders = () => {
  return dispatch => (
    dispatch({
      [CALL_API]: {
        endpoint: api.getAllTeamLeaders(),
        method: HTTP_GET,
        types: [
          REQUEST_FR_TEAMLEADERS,
          {
            type: RECEIVE_FR_TEAMLEADERS,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_FR_TEAMLEADERS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    })
  );
};

// export const getAllTrainingCoordinators = () => {
//   return dispatch => (
//     dispatch({
//       [CALL_API]: {
//         endpoint: api.getAllTrainingCoordinators(),
//         method: HTTP_GET,
//         types: [
//           REQUEST_FIELD_REP_DEVELOPMENT_MANAGER_LIST,
//           {
//             type: RECEIVE_FIELD_REP_DEVELOPMENT_MANAGER_LIST,
//             payload: (action, state, res) =>
//               res.json()
//                 .then(data => {
//                   return data;
//                 })
//           }, {
//             type: ERROR_FIELD_REP_DEVELOPMENT_MANAGER_LIST,
//             payload: (action, state, res) => {
//               responseHandler.error(res, dispatch);
//             }
//           }
//         ]
//       }
//     })
//   );
// };

export const getMinimalInspectorListByCase = (controlIdNumber) => WebApiReduxRequest(
  REQUEST_MINIMAL_FIELD_REP_LIST_FOR_CASE,
  RECEIVE_MINIMAL_FIELD_REP_LIST_FOR_CASE,
  ERROR_MINIMAL_FIELD_REP_LIST_FOR_CASE,
  HTTP_GET,
  api.getMinimalInspectorListByCase(controlIdNumber)
);

export const getFieldRepExclusionSearchResults = (customerNumber, file, matchTypes) => {
  const data = new FormData();
  data.append("file", file);

  return dispatch => (
    dispatch({
      [CALL_API]: {
        endpoint: customerInspectorExclusions.findInspectors(customerNumber, matchTypes),
        method: HTTP_POST,
        body: data,
        requestType: "upload", // This will get picked up in the middlewares/genericHeaders/index.js and it will delete our Content-Type that it usually sets so the browser can generate a proper Content-Type
        types: [
          REQUEST_FR_EXCLUSION_SEARCH_RESULTS,
          {
            type: RECEIVE_FR_EXCLUSION_SEARCH_RESULTS,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  setTimeout(() => {
                    if (data.error) {
                      responseHandler.clientErrors(data.errorMessages, dispatch);
                    }
                  }, 0);
                  return data;
                })
          },
          {
            type: ERROR_FR_EXCLUSION_SEARCH_RESULTS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
              return;
            }
          }
        ]
      }
    })
  );
};

export const updateFRServiceBoundary = (inspectorNumber, boundary, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  payload: boundary,
  endpoint: api.updateFRServiceBoundary(inspectorNumber),
  successCallback,
  errorCallback,
  mountedRef,
});
